import React from "react";
import { FaMars, FaVenus, FaGenderless } from "react-icons/fa";

const GenderIcon = ({ gender, className = "" }) => {
    switch (gender) {
        case "M":
            return <FaMars className={`text-blue-500 ${className}`} />;
        case "F":
            return <FaVenus className={`text-pink-500 ${className}`} />;
        default:
            return <FaGenderless className={`text-gray-500 ${className}`} />;
    }
};

export default GenderIcon;